import { useEffect, useRef } from 'react'

import usePageConfig from 'Pods/Shared/Hooks/usePageConfig'
import { hydrateSubscription } from 'Pods/ThreeDStudio/Store/actions/subscription'

const isNumber = (value) => typeof value === 'number'
const isString = (value) => typeof value === 'string'
const isBoolean = (value) => typeof value === 'boolean'

const OVERWRITE_MAP = {
  monthlyGenerationsAvailable: { key: 'threeDStudioMonthlyGenerationsAvailable', isValid: isNumber },
  monthlyGenerationsUsed: { key: 'threeDStudioMonthlyGenerationsUsed', isValid: isNumber },
  extraGenerationsAvailable: { key: 'threeDStudioExtraGenerationsAvailable', isValid: isNumber },
  extraGenerationsUsed: { key: 'threeDStudioExtraGenerationsUsed', isValid: isNumber },
  generationCost: { key: 'threeDStudioGenerationCost', isValid: isNumber },
  concurrencyCap: { key: 'threeDStudioConcurrencyCap', isValid: isNumber },
  multipleGenerationsEnabled: { key: 'threeDStudioMultipleGenerationsEnabled', isValid: isBoolean },
}

const PRESERVE_IF_SET_MAP = {
  studioAccessTier: { key: 'threeDStudioAccessTier', isValid: isString },
  premiumFeatures: { key: 'threeDStudioPremiumFeatures', isValid: isBoolean },
  subscriptionPrice: { key: 'threeDStudioSubscriptionPrice', isValid: isString },
  subscriptionOriginalPrice: { key: 'threeDStudioSubscriptionOriginalPrice', isValid: isString },
  subscriptionResetDate: { key: 'threeDStudioSubscriptionResetDate', isValid: isString },
  extraGenerationsPrice: { key: 'threeDStudioExtraGenerationsPrice', isValid: isString },
  subscriptionMonthlyGenerations: { key: 'threeDStudioSubscriptionMonthlyGenerations', isValid: isNumber },
  subscriptionMonthlyModels: { key: 'threeDStudioSubscriptionMonthlyModels', isValid: isNumber },
  subscriptionPaymentFormUrl: { key: 'threeDStudioSubscriptionPaymentFormUrl', isValid: isString },
}

const buildPatch = (pageConfig, fieldMap) => {
  const patch = {}
  Object.entries(fieldMap).forEach(([sliceKey, { key, isValid }]) => {
    if (isValid(pageConfig[key])) {
      patch[sliceKey] = pageConfig[key]
    }
  })
  return patch
}

export default function useHydrateGenerationQuota() {
  const pageConfig = usePageConfig()
  const isLoggedIn = pageConfig?.isCurrentUser ?? false
  const hasHydrated = useRef(false)

  useEffect(() => {
    if (!isLoggedIn || hasHydrated.current) {
      return
    }

    hasHydrated.current = true

    hydrateSubscription({
      overwrite: buildPatch(pageConfig, OVERWRITE_MAP),
      preserveIfSet: buildPatch(pageConfig, PRESERVE_IF_SET_MAP),
    })
  }, [isLoggedIn, pageConfig])
}
